(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf-pages.page-5
  (:require [frontend.ui.component.lp-portal.page.pdf.view :as page]
            [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
            [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
            [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]))

(defn sustainability-text
  [{:keys [sustainability-text-1 sustainability-text-2 sustainability-text-3] :as data}]

  [(card/card
    ""
    (text-content/rich-content (->> sustainability-text-1
                                    :rich-content)))
   (card/one-third-row-card
    ""
    (column/half-columns

     (text-content/rich-content (->> sustainability-text-2
                                     :rich-content))
     (text-content/rich-content (->> sustainability-text-3
                                     :rich-content))))])
(defn view
  [data]
  (page/page
   (page/page-title-with-line {:fund-name  (:fund-name data)
                               :reference-date (:reference-date data)
                               :lower-case-title? true})

   [(sustainability-text data)]))
